import styled, { css } from 'styled-components';
import { space, color, layout, border, typography } from 'styled-system';
import { getTextColor, themeGet, getPaletteColor } from '@magalu/stereo-ui-styles';
import Flex from '../../atoms/Flex';
import TextElement from '../../atoms/Text';
import Card from '../../atoms/Card';
const titleStyle = css`
  color: ${props => getTextColor('base')(props)};
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  max-width: 97%;
`;
const container = {
  miniature: css`
    display: grid;
    padding: 8px 2px;
  `,
  list: css`
    display: grid;
    grid-template-columns: 1fr 2fr;
    padding: 16px;
  `,
  gallery: css``,
  none: css`
    display: contents;
  `,
  button: css`
    display: block;
    padding: 16px 16px 6px;
  `
};
const imgContainerDisplay = {
  miniature: css`
    height: 20vw;
    justify-content: flex-end;
    & > span {
      display: block;
      width: 100%;
      height: 100%;
    }
  `,
  list: css`
    justify-content: flex-start;
    padding-top: 4px;
    min-height: 25vw;
  `,
  gallery: css`
    height: 32vw;
    justify-content: flex-end;
    & > span {
      display: block;
      width: 100%;
      height: 100%;
    }
  `
};
export const Display = styled(Card)`
  background-color: ${props => getPaletteColor('background.lighter')(props)};
  padding: 0;
  ${({
  displayMode
}) => displayMode && container[displayMode]}
`;
export const ImageContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding-right: ${props => themeGet('space.2')(props)}px;
  ${({
  displayMode
}) => displayMode && imgContainerDisplay[displayMode]}
`;
export const TitleDisplay = styled.div`
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  grid-column-start: ${({
  betterOffer
}) => betterOffer && 2};
  ${({
  highlight,
  highlightType,
  sponsored
}) => highlight && !highlightType ? css`
          margin: ${themeGet('space.0')}px ${themeGet('space.2')}px;
        ` : css`
          margin-bottom: ${sponsored ? themeGet('space.2') : themeGet('space.3')}px;
        `};
`;
export const Title = styled(TextElement).attrs(({
  highlight,
  fontSize
}) => ({
  fontSize: fontSize !== null && fontSize !== void 0 ? fontSize : [highlight ? 1 : 2, 4, 5],
  lineHeight: 'display',
  fontWeight: 'medium'
}))`
  ${titleStyle}
  ${typography}

  & > span {
    font-weight: ${props => themeGet('fontWeights.bold')(props)};
  }
`;
export const ButtonTitle = styled.h2`
  ${titleStyle}
  height: 32px;
  line-height: ${props => themeGet('lineHeights.plus')(props)}px;
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  font-weight: ${props => themeGet('fontWeights.regular')(props)};
  margin: 0 0 4px 0;
`;
export const ProductCard = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
`;
export const TextHighlight = styled(TextElement).attrs(() => ({
  fontSize: [1, 4, 5],
  lineHeight: 'display',
  fontWeight: 'regular'
}))`
  ${titleStyle}
  ${typography}
`;
export const Content = styled.div`
  display: grid;
`;
export const Container = styled.div`
  box-shadow: ${({
  exhibition
}) => exhibition === 'highlight' ? '0 4px 10px 0 rgba(0, 0, 0, 0.11)' : 'unset'};
  border-radius: ${({
  exhibition
}) => exhibition === 'highlight' && '4px'};
  overflow: hidden;
  ${({
  exhibition
}) => exhibition === 'betteroffer' && css`
      display: grid;
      grid-template-rows: auto auto;
      padding: 24px 0;
      grid-template-columns: 1fr minmax(auto, 1376px) 1fr;
    `}
  ${space}
  ${color}
  ${layout}
  ${border}
`;
export const ProductCardContent = styled(Flex)`
  flex: 1;
  flex: 0 0 calc(100% / 4);
  border-right: ${themeGet('borders.0')};
  border-width: 2px;
`;
export const SponsoredSubTitle = styled(TextElement).attrs(() => ({
  fontSize: 0,
  color: 'light',
  marginTop: 1
}))``;
export const ShowcaseContent = styled.div`
  grid-column-start: 2;
`;